import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Badge from 'react-bootstrap/Badge';
import ListGroup from 'react-bootstrap/ListGroup';
import { BreathAPIs } from '../APIs/BreathAPIs'
import styles from './style.module.css';
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';
import BookingCancel from './components/BookingCancel';

function PaymentHistory({ balance, paymentHistoryPageNumber, setPaymentHistoryPageNumber, timeFormatAmPm }) {
    const [paymentHistory, setPaymentHistory] = useState([])
    const [isLoading, setIsLoading] = useState(false);

    const [pagination, setPagination] = useState({})

    const getHistory = async () => {
        try {
            setIsLoading(true);
            
            const res = await BreathAPIs.getPaymentHistory(pagination?.current ? pagination?.current + 1 : 1);
            const newHistory = res?.data?.transactionHistory || [];
    
            setPaymentHistory((prevHistory) => {
                const existingIds = new Set(prevHistory.map((item) => item._id));
                const filteredHistory = newHistory.filter((item) => !existingIds.has(item._id));
                return [...prevHistory, ...filteredHistory];
            });
    
            setPagination(res?.data?.pagination || {});
        
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching payment history:', error);
            setIsLoading(false);
        }
    };
    
    // useEffect(()=>{
    //     setPagination({});
    //     setPaymentHistory([]);
        
    // },[])

    useEffect(() => {
        getHistory();
    }, [])
    // console.log(paymentHistory)

    const getFormattedDate = (timestamp) => {
        const date = new Date(timestamp);
        const newDate = date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: timeFormatAmPm,
        });
        return newDate;
    }

    return (
        <div>
            <h5> Payment History </h5>

            <div className={styles.historyContainer}>
            <ListGroup as="ol" >

                {paymentHistory?.map((history) => (
                    <ListGroup.Item
                        as="li"
                        key={history._id}
                    >
                        <div className="ms-2 me-auto">
                            <div className={styles['history-row']}>
                                <div className="fw-bold text-capitalize">{history.type}ed</div>
                                <Badge bg={history.type === "Credit" ? "success" : "danger"} pill>
                                    ${history.amount.toFixed(2)}
                                </Badge>
                            </div>
                            
                            {getFormattedDate(history.date * 1000)}
                            {<BookingCancel timeFormatAmPm={timeFormatAmPm} history={history} />}
                            {history?.particular ? <div className='fst-italic text-muted'>{history?.particular}</div> : null}
                        </div>

                    </ListGroup.Item>
                ))}
            </ListGroup>
            </div>
            {/* <div className='mt-3' onClick={() => { setPaymentHistoryPageNumber(paymentHistoryPageNumber + 1) }}>Load more</div> */}
           {pagination?.total === 0 
           ?
                <div className={styles['empty-history']}>No Transactions.</div>
           :
                <div className='text-center mt-3'>

                    {
                        pagination?.current ===  pagination?.totalPages
                        ?
                        <></>
                        :
                        <ButtonCustom disabled={isLoading} isLoading={isLoading} text={isLoading ? 'loading...' : 'more'} onClick={() => { getHistory() }} style={{padding:'2px 14px', fontSize: '14px', borderRadius:'13px'}} variant={"primary"}  ></ButtonCustom>
                    }
                </div>
            }
            
        </div>
    )
}

PaymentHistory.propTypes = {
    balance: PropTypes.number,
    timeFormatAmPm: PropTypes.bool,
}

const mapStateToProps = state => ({
    balance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
    timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
})

export default connect(mapStateToProps, {})(PaymentHistory);